<div class="selection-card" [class.has-cover]="selection().cover?.url" (click)="onClick()">
  @if (selection().cover?.url) {
    <div class="card-thumb">
      <img [src]="selection().cover?.url" [alt]="selection().name" class="cover-image" />
      <div class="card-gradient"></div>
    </div>
  } @else {
    <div class="card-cover card-cover--empty"></div>
  }

  <div class="card-info">
    <div class="card-title-row">
      <span class="card-name">{{ selection().name }}</span>
      <span class="card-count">{{ selection().posts_uuids?.length || 0 }}</span>
    </div>
  </div>

  <div class="card-menu-area" [class.menu-visible]="menuOpen()" (click)="$event.stopPropagation()">
    <outlaw-selection-card-menu [items]="menuItems()" (itemClicked)="onMenuAction($event)" (openChanged)="menuOpen.set($event)" />
  </div>
</div>
